import { defineStore } from 'pinia'
import AnalyticsService from '../service/AnalyticsService';
const analyticsService = new AnalyticsService();
export const useAnalyticsStore = defineStore({
  id: 'analytics',
  state: () => ({
    // dynamicKPI: {},
    loading: false,
    error: null,
    colorPalette: ["#968870", "#8CC168", "#FF7733", "#FFA04C", "#4472C4", "#91B6F8", "#B9E09F", 
      "#BFB086", "#D20C30", "#D4526E", "#5EC3CC", "#FFD966", "#43682B", "#0E9E70",
      "#969696", "#264478", "#CC9A00", "#9380FF", "#F1D335", "#546E7A", "#33B2DF"],
    filters: [],
    filters_singleAnalytics: [],
    filter_status_analytics: null,
    filterPageAnalytics: {},
    generalOptions: {
      noData: {
        text: "Loading chart...",
        align: "center",
        verticalAlign: "middle",
        offsetX: 0,
        offsetY: 0,
        style: {
          color: undefined,
          fontSize: "14px",
          fontFamily: undefined,
        },
      },
      chart: {
        height: 50,
        width: 50,
      },
      // theme: {
      //     palette: 'palette10' // upto palette10
      // },
      dataLabels: {
        enabled: false,
      },
    },
  }),
  getters: {
    // getDynamicKPI: (state) => {
    //   return state.dynamicKPI;
    // },
    getAnalyticsFiltersList: (state) => {
      return state.filters;
    },
    getSingleAnalyticsFiltersList: (state) => {
      return state.filters_singleAnalytics;
    },
    getAnalyticsStatusFilter: (state) => {
      return state.filter_status_analytics;
    },
    getAnalyticsPageFilter: (state) => {
      return state.filterPageAnalytics;
    },
    getColorPalette: (state) => {
      return state.colorPalette;
    },
  },
  actions: {
    setAnalyticsStatusFilter(status_filters) {
      this.filter_status_analytics = status_filters;
    },
    setAnalyticsFiltersList(filters) {
      this.filters = filters;
    },
    setSingleAnalyticsFiltersList(filters) {
      this.filters_singleAnalytics = filters;
    },
    // setDynamicKPI(dynamicKPIResponse) {
    //   this.dynamicKPI = dynamicKPIResponse;
    // },
    setAnalyticsPageFilter(page, filter) {
      this.filterPageAnalytics[page] = filter;
    },
    // async getKPIConfig() {
    //   this.loading = true
    //   try {
    //     await analyticsService.getKPIConfig("TOKEN DEi KPI analitici").then((response) => {
    //       this.setDynamicKPI(response);
    //     });
    //   } catch (error) {
    //     this.error = error
    //   } finally {
    //     this.loading = false
    //   }
    // },
    getBarChartOptions(chart) {
      let options = {...this.generalOptions};
      options.fill = { colors: this.colorPalette };
      options.xaxis = { categories: chart.x , tickAmount: 5,};
      options.yaxis = {
        labels: {
          formatter: function (val) {
            return val.toFixed(0);
          }
        },
      };
      // prevent to display infinity when there are no values
      let maxY = Math.max.apply(Math, [...chart.y, 1]);
      if (maxY === 1)
        options.yaxis.max = maxY;
      options.chart.toolbar = {
        show:false
      }
      return options;
    },
    getPieChartOptions(chart) {
      let options = {...this.generalOptions};
      options.colors = this.colorPalette;
      // options.fill = { colors: this.colorPalette };
      options.labels = chart.x.map((x) => x.toString());
      options.yaxis = {
        labels: {
          formatter: function (val) {
            return val.toFixed(0);
          }
        },
      };
      options.legend = {
        position: "right",
        width: 110,
        horizontalAlign: 'left',
        markers: {
            // width: 9, height: 9, fillColors: this.colorPalette,
        },
        itemMargin: {
            horizontal: -10, vertical: 0
        },
      };
      return options;
    },
    getLineChartOptions(chart) {
      let options = {...this.generalOptions};
      options.colors = this.colorPalette;
      options.xaxis = {type: "datetime"};
      options.yaxis = {
        labels: {
          formatter: function (val) {
            return val.toFixed(0);
          }
        },
      };
      options.zoom = {
        type: "x",
        enabled: true,
        autoScaleXaxis: true,
      };
      options.stacked = false;
      options.toolbar = {autoSelected: "zoom"};   
      options.labels = chart.x;
      options.tooltip = {
        x: {
          formatter: function (val) {
            // Formatta la data per mostrare giorno, mese e ora
            const date = new Date(val);
            const options = { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' };
            return date.toLocaleString('it-IT', options);
          }
        }
      };
      return options;
    },
  }
})


